<button #upButton class="up-button" (click)="scrollToTop($event)">
  <div class="up-container">
    <i class="fas fa-angle-up up-icon"></i>
  </div>
</button>
